import React from "react";
import compose from "lodash/fp/compose";
import gql from "graphql-tag";
import { graphql } from "react-apollo";

import { convertMutationErrors } from "../shared/util/graphql";

import SessionView from "./ui/SessionView";

const setQuery = gql`
  {
    me {
      user {
        id
        licenseId
        isAdmin
      }
    }
    licenseSet {
      id
      name
    }
    scenarioSet {
      id
      name
    }
    sessionSet {
      id
      licenseId
      scenarioId
      pin
      masterPassword
      isActive
    }
  }
`;

const createMutation = gql`
  mutation($input: CreateSessionInput!) {
    create: createSession(input: $input) {
      session {
        id
      }
      errors {
        key
        message
      }
    }
  }
`;

const updateMutation = gql`
  mutation($input: UpdateSessionInput!) {
    update: updateSession(input: $input) {
      session {
        id
      }
      errors {
        key
        message
      }
    }
  }
`;

const deleteMutation = gql`
  mutation($input: DeleteSessionInput!) {
    delete: deleteSession(input: $input) {
      session {
        id
      }
    }
  }
`;

class C extends React.Component {
  handleCreate = async (values) => {
    const { data, createMutation } = this.props;
    const result = await createMutation({ variables: { input: values } });
    const errors = result.data.create.errors;
    if (errors) {
      return convertMutationErrors(errors);
    }
    await data.refetch();
  };

  handleUpdate = async ({ id, ...values }) => {
    const { data, updateMutation } = this.props;
    const result = await updateMutation({
      variables: { input: { ...values, id } },
    });
    const errors = result.data.update.errors;
    if (errors) {
      return convertMutationErrors(errors);
    }
    await data.refetch();
  };

  handleDelete = async ({ id }) => {
    const { data, deleteMutation } = this.props;
    await deleteMutation({ variables: { input: { id } } });
    await data.refetch();
  };

  render() {
    return (
      <SessionView
        data={this.props.data}
        onCreate={this.handleCreate}
        onUpdate={this.handleUpdate}
        onDelete={this.handleDelete}
      />
    );
  }
}

export default compose(
  graphql(createMutation, { name: "createMutation" }),
  graphql(updateMutation, { name: "updateMutation" }),
  graphql(deleteMutation, { name: "deleteMutation" }),
  graphql(setQuery, { options: { fetchPolicy: "network-only" } })
)(C);
